import { getChildrenCategories, getFirstLevelCategories } from 'lib/core/resources/helpers'
import { Category, CategoryList } from 'lib/types'

interface Deps {
  category: Category
  categoryList: CategoryList
}

export type CategoryTree = Array<{
  category: Category
  children: CategoryTree | undefined
}>

export const getChildrenCategoryTree = ({ category, categoryList }: Deps): CategoryTree | undefined => {
  const categories = getChildrenCategories(category, categoryList)

  return categories?.map(el => {
    return {
      category: el,
      children: getChildrenCategoryTree({ category: el, categoryList })
    }
  })
}

export const getCategoryTree = (categoryList: CategoryList): CategoryTree => {
  const items = categoryList.list.filter(getFirstLevelCategories)

  return items.map((el) => {
    return {
      category: el,
      children: getChildrenCategoryTree({
        category: el,
        categoryList
      })
    }
  })
}
